import { createFileRoute } from "@tanstack/react-router";
import { CrudTable, type FieldDef } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/badges")({
  component: AdminBadges,
});

function AdminBadges() {
  const fields: FieldDef[] = [
    { key: "slug", label: "Slug", required: true },
    { key: "name", label: "الاسم", required: true },
    { key: "description", label: "الوصف", type: "textarea" },
    { key: "icon", label: "Icon (emoji)" },
    { key: "color", label: "اللون (hex)", defaultValue: "#6366f1" },
    {
      key: "criteria_type",
      label: "النوع (manual/quizzes_completed/perfect_quiz/lessons_completed/points/streak_days)",
    },
    { key: "criteria_value", label: "قيمة المعيار", type: "number" },
  ];
  return (
    <CrudTable
      title="Badges"
      table="badges"
      fields={fields}
      orderBy={{ column: "created_at", ascending: true }}
      columns={[
        { key: "icon", label: "Icon" },
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug" },
        { key: "criteria_type", label: "Criteria" },
      ]}
    />
  );
}
